import type { SerializedError } from '@reduxjs/toolkit';

import axios from 'axios';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const accessTokenJSON = localStorage.getItem('auth');

import initialConfig from '../initialConfig';

const initialState: {
  userRateBlogMutationData: any;
  userRateBlogMutationLoading: boolean;
  userRateBlogMutationError: SerializedError | null;
} = {
  userRateBlogMutationData: {},
  userRateBlogMutationLoading: false,
  userRateBlogMutationError: null,
};

export const userRateBlogMutationFunc = createAsyncThunk(
  'userRateBlogMutation/userRateBlogMutationFunc',
  async (values: {
    rateBlogInput: {
      blogId: string;
      rating: number;
      comment: string;
    };
  }) => {
    const data1 = JSON.stringify({
      query: `mutation UserRateBlog($rateBlogInput: RateBlogInput!) {
        user_rateBlog(rateBlogInput: $rateBlogInput) {
            average
            createdAt
            numberOfReviews
            updatedAt
        }
    }`,
      variables: {
        rateBlogInput: {
          blogId: values?.rateBlogInput?.blogId ?? null,
          rating: values?.rateBlogInput?.rating ?? null,
          comment: values?.rateBlogInput?.comment ?? null,
        },
      },
    });

    const config = initialConfig(
      process.env.REACT_APP_BASE_URL_ACTIVITY || '',
      data1,
      accessTokenJSON ? JSON.parse(accessTokenJSON).accessToken : ''
    );

    const response = axios(config)
      .then((res) => {
        const data = res.data;
        return data;
      })
      .catch((err) => err);

    const data = await response;
    return data;
  }
);

const userRateBlogMutation = createSlice({
  name: 'userRateBlogMutation',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(userRateBlogMutationFunc.pending, (state) => {
      state.userRateBlogMutationLoading = true;
    });
    builder.addCase(userRateBlogMutationFunc.fulfilled, (state, action) => {
      state.userRateBlogMutationLoading = false;
      state.userRateBlogMutationData = action.payload?.data?.userRateBlogMutation;
      state.userRateBlogMutationError =
        action.payload.errors || action.payload?.response?.status;
    });
    builder.addCase(userRateBlogMutationFunc.rejected, (state, action) => {
      state.userRateBlogMutationLoading = false;
      state.userRateBlogMutationError = action.error;
    });
  },
});

export default userRateBlogMutation.reducer;
